/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:d1ef2d15-cfb4-49cd-ad1c-23ab1a2c629c",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_wUfEB7Xew",
    "aws_user_pools_web_client_id": "31gqgmfn5k5o5vsahb14m3f4l3",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "temperaturetrackapi",
            "endpoint": "https://umh0ervk5h.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "TemperatureTrack-Users-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "TemperatureTrack-Groups-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "TemperatureTrack-GroupsUsersAux-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "TemperatureTrack-HealthUpdates-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "TemperatureTrack-AccessCodes-prod",
            "region": "us-east-1"
        },
        {
            "tableName": "TemperatureTrack-Assessments-prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
